import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver marked the unit as being used for personal conveyance.
 */
export const personalConveyanceV1 = tmsEventKind(
  { category: "specialDriving", kind: "personalConveyance", version: 1 },
  { refs: dutyStatusChangeRefs, facts: {} },
);

export const PersonalConveyanceV1Schema = personalConveyanceV1.schema;
export const PersonalConveyanceV1FactsSchema = personalConveyanceV1.facts;

export type PersonalConveyanceV1 = z.infer<typeof PersonalConveyanceV1Schema>;
export type PersonalConveyanceV1Facts = z.infer<typeof PersonalConveyanceV1FactsSchema>;

/** Every version of `personalConveyance`, keyed by version. What `catalog.ts` places under `specialDriving`. */
export const personalConveyance = { 1: personalConveyanceV1 } as const;
